import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { IConsultant, saveNewConsultant } from 'wisestep-api';
import { FormWizard, ScrollableTabs } from 'wisestep-base';

import { emptyConsultant } from '../../../helper/EmptyConsultant';
import OwnerInfo from '../../../imports/components/singleImport/OwnerInfo';
import PrimaryInfo from '../../../imports/components/singleImport/PrimaryInfo';
import SecondaryInfo from '../../../imports/components/singleImport/SecondaryInfo';

import RenderBroadCastInfo from './RenderBroadcastInfo';

interface IBroadcastProps {
  onClick: () => void;
  consultantData: IConsultant;
}

const ConsultantInfo = ({ consultantData }: IBroadcastProps) => {
  const [consultant, setConsultant] = useState<IConsultant>(emptyConsultant.consultants[0]);
  const [tabPanelPage, setTabPanelPage] = useState(0);
  const [updateState, setUpdateState] = useState(false);

  const handleTabClick = (index: number) => setTabPanelPage(index);

  const [currentOption, setCurrentOption] = useState<number>(0);

  const addConsultantInfo = (data) => {
    if (data) {
      setConsultant((prev) => ({ ...prev, ...data }));
    }
  };
  const createNewConsultant = async () => {
    try {
      await saveNewConsultant({ consultants: [consultant] });
    } catch (e) {
      console.log(e);
    }
  };
  const renderForm = () => {
    switch (currentOption) {
      case 0:
        return (
          <PrimaryInfo
            newConsultant={addConsultantInfo}
            setCurrentTab={setCurrentOption}
            consultantData={{ ...consultant }}
          />
        );
      case 1:
        return <SecondaryInfo newConsultant={addConsultantInfo} setCurrentTab={setCurrentOption} />;
      case 2:
        return (
          <OwnerInfo
            newConsultant={addConsultantInfo}
            postNewConsultant={createNewConsultant}
            setCurrentTab={setCurrentOption}
            consultantData={{ ...consultant }}
          />
        );
    }
  };

  useEffect(() => setConsultant(consultantData), [consultantData]);

  const renderPage = (tabId) => (
    <RenderBroadCastInfo
      tabId={tabId}
      consultantData={consultantData}
      setUpdateState={setUpdateState}
    />
  );

  return (
    <>
      {updateState ? (
        <FormWizard
          menuItems={[
            {
              id: 0,
              label: 'Primary Info',
              onClick: () => setCurrentOption(0),
            },
            {
              id: 1,
              label: 'Secondary Info',
              onClick: () => setCurrentOption(1),
            },
            {
              id: 2,
              label: 'Owner Info',
              onClick: () => setCurrentOption(2),
            },
          ]}
          currentStep={currentOption}
          title="Update Consultant Info"
          onArrowButtonClick={() => setUpdateState(false)}
        >
          <Box pr={4} width="100%" minHeight="100%" ml={3}>
            {renderForm()}
          </Box>
        </FormWizard>
      ) : (
        <>
          <ScrollableTabs
            scrollList={[
              { tabName: 'Primary Info' },
              { tabName: 'Secondary Info' },
              { tabName: 'Owner Info' },
            ]}
            getTabIndex={(index: number) => handleTabClick(index)}
          />
          <Box mt={1}>{renderPage(tabPanelPage)}</Box>
        </>
      )}
    </>
  );
};

export default ConsultantInfo;
